import typo from '../style/typefaces'
import evaluator from '../style/evaluator'
import grid from '../style/grid'
import mq from '../style/media_queries'

export default {
  content_root:{
    paddingTop: grid.row(3)
  }
}



// WEBPACK FOOTER //
// ./src/about/style.js